  /* jshint esversion: 6 */
/* jshint ignore:start */
import { useContext, useEffect, useState } from 'react';
import { MyContext } from '../Context/MyProvider';
import axios from 'axios';
import Slider from "react-slick";
import { useNavigate } from 'react-router-dom';
import secureLocalStorage from "react-secure-storage";
import { useTranslation } from 'react-i18next';
import CryptoJS from 'crypto-js';

export const ImgLoad = ({ url }) => {

  const [imgLoaded, setImgLoaded] = useState(false);

  return (<>
    <img
      src={url}
      alt="Model"
      onLoad={() => setImgLoaded(true)}
      onError={() => setImgLoaded(true)}
      className={`mx-auto h-[120px] object-contain transition-opacity duration-300 ${imgLoaded ? "opacity-100" : "opacity-0"}`}
    />
  </>
  )
}

const Dashboard = () => {

  const { t } = useTranslation();
  const { ApiBasUrl, ImgBasUrl, callapi, setTotalCart, setShowLoginPage, setMapKey, setIsInstallable, isInstallable, SECRET_KEY } = useContext(MyContext);

  const [bannerlist, setBannerList] = useState([]);
  const [categorylist, setCategoryList] = useState([]);
  const [servicelist, setServiceList] = useState([]);
  const [combolist, setComboList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [apierror, setApiError] = useState("");

  const Navigate = useNavigate();

  const settings = {
    dots: true,
    infinite: true,
    arrows: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      { breakpoint: 1510, settings: { slidesToShow: 2, slidesToScroll: 1 } },
      { breakpoint: 770, settings: { slidesToShow: 1, slidesToScroll: 1 } },
    ],
  };

  useEffect(() => {
    HandleFetchHomeData();
  }, [callapi]);

  const HandleFetchHomeData = () => {

    const Userid = secureLocalStorage.getItem("Userid") || 0;
    const SelectStore = secureLocalStorage.getItem("Store");
    const SelectCar = secureLocalStorage.getItem("Selectcar");

    setApiError("");
    setLoading(true);

    if (SelectCar && SelectStore) {
      var { store_id } = JSON.parse(SelectStore);
      var { cat_id, brand_id, model_id } = JSON.parse(SelectCar);
    } else {
      if (Userid !== 0) {
        setApiError("Please select vehicle or store !!");
      }
    }

    const Data = {
      uid: Userid,
      store_id: store_id || "1",
      cat_id: cat_id || "1",
      brand_id: brand_id || "1",
      model_id: model_id || "1"
    }

    axios.post(`${ApiBasUrl}/home_data.php`, Data)
      .then((res) => {
        const { banner, category, custom_service, combo, g_key } = res.data;
        setBannerList(banner);
        setCategoryList(category);
        setServiceList(custom_service);
        setComboList(combo);
        secureLocalStorage.setItem("currency", res.data.currency);
        secureLocalStorage.setItem("servicefees", res.data.service_fees);
        secureLocalStorage.setItem("mywallet", res.data.wallet);
        setMapKey(g_key);
        setLoading(false);
      })
      .catch((error) => {
        console.error("home_data.php", error);
      })
  }

  const HandleNavigate = (id) => {
    if (isInstallable) {
      setIsInstallable(false);
      secureLocalStorage.setItem("pwa", false);
    }
    sessionStorage.setItem("Categoryid", id);
    Navigate("/category-details");
  }

  const HandleAddCart = (data) => {
    const Userid = secureLocalStorage.getItem("Userid");

    if (isInstallable) {
      setIsInstallable(false);
      secureLocalStorage.setItem("pwa", false);
    }

    if (!Userid) {
      setShowLoginPage(true);
      return;
    }

    const LocalCartData = localStorage.getItem("Cartitem");

    let packagecartitem = [];
    let cartitem = [];

    if (LocalCartData) {
      const bytes = CryptoJS.AES.decrypt(LocalCartData, SECRET_KEY);
      const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      packagecartitem = decryptedData.packagecartitem || [];
      cartitem = decryptedData.cartitem || [];
    }

    let packageitem = [];

    if (packagecartitem && packagecartitem.length > 0) {
      packageitem = data.filter(item => {
        return !packagecartitem.some(service => service.service_id === item.service_id);
      });
    } else {
      packageitem = data;
    }

    const Edititem = packageitem.map(item => ({
      ...item,
      totalcart: 1,
      item_type: 'service'
    }));

    const combinedCartItems = { packagecartitem: [...Edititem, ...packagecartitem], cartitem: [...cartitem] };
    const combineLength = [...Edititem, ...packagecartitem, ...cartitem];

    if (combineLength.length > 0) {
      const encrypted = CryptoJS.AES.encrypt(JSON.stringify(combinedCartItems), SECRET_KEY).toString();
      localStorage.setItem('Cartitem', encrypted);
    } else {
      localStorage.removeItem("Cartitem");
    }

    setTotalCart(combineLength.length);

    Navigate("/cart", { state: { title: "Home", path: "/" } });
  }

  return (
    <div className="dashboard">
      {loading
        ? <div className="w-full h-[100vh] bg-white fixed top-0 flex items-center justify-center">
          <div className="loader2"></div>
        </div>
        : <div className="">
          {apierror
            ? <div className="w-full h-[100vh] bg-white fixed top-0 flex items-center justify-center z-[777]">
              <h1 className='font-bold text-[25px] text-gray-600'>{t(apierror)}</h1>
            </div>
            : <div className="badder_slider my-[20px]">
              <div className="slider-container pb-[20px]">
                <Slider {...settings}>
                  {bannerlist?.map((item, index) => {
                    return <div key={index} onClick={() => HandleNavigate(item.cat_id)} className="h-[300px] max-_430_:h-[250px] cursor-pointer">
                      <img src={ImgBasUrl + item.img} className="w-full h-full object-cover rounded-[15px]" alt="Banner" />
                    </div>
                  })}
                </Slider>
              </div>

              <div className="width_container">
                <div className="section_category">
                  <h1 className="title">{t("Categories")}</h1>
                  <div className="my-[10px] flex-wrap flex items-center gap-[20px]">
                    {categorylist?.map((item, index) => {
                      return <div key={index} onClick={() => HandleNavigate(item.id)} className="category_box">
                        <ImgLoad url={ImgBasUrl + item.category_image} />
                        <h1 className="text-[15px] mt-[10px]">{item.category_title}</h1>
                      </div>
                    })}
                  </div>
                </div>

                {servicelist.length >= 1 && <div className="section_service">
                  <h1 className="title">{t("Curated Custom Services")}</h1>
                  <div className="my-[10px] flex-wrap flex items-center gap-[20px]">
                    {servicelist?.map((item, index) => {
                      return <div key={index} onClick={() => HandleNavigate(item.custom_cat_id)} className="service_box">
                        <img src={ImgBasUrl + item.custom_service_image} className="mx-auto h-[120px] object-contain" alt="category_image" />
                        <h1 className="text-[15px] mt-[10px]">{item.custom_service_title}</h1>
                      </div>
                    })}
                  </div>
                </div>}

                {combolist.length >= 1 && <div className="section_combo">
                  <h1 className="title">{t("Designer Service Combos")}</h1>
                  <div className="my-[10px] flex-wrap flex items-center gap-[15px]">
                    {combolist?.map((item, index) => {
                      const ToUpperCase = item.combo_title.toUpperCase();
                      return <div key={index} onClick={() => HandleAddCart(item.combo_service_list)} className="combo_box cursor-pointer">
                        <div className="image">
                          <img src={ImgBasUrl + item.combo_img} className="w-full h-[100px] object-cover" alt="combo_img" />
                          <h1 className="absolute top-[10px] left-[10px] font-bold z-10 text-white">{ToUpperCase}</h1>
                        </div>
                        <div className="px-[10px] py-[5px] flex items-center gap-[10px]">
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M21.75 7V11.1541C21.75 11.5681 21.414 11.9041 21 11.9041C20.586 11.9041 20.25 11.5681 20.25 11.1541V8.81104L14.237 14.824C13.554 15.507 12.445 15.507 11.762 14.824L9.176 12.238C9.078 12.14 8.92001 12.14 8.82201 12.238L3.529 17.531C3.383 17.677 3.191 17.751 2.999 17.751C2.807 17.751 2.615 17.678 2.469 17.531C2.176 17.238 2.176 16.763 2.469 16.47L7.762 11.177C8.445 10.494 9.554 10.494 10.237 11.177L12.823 13.7629C12.921 13.8609 13.079 13.8609 13.177 13.7629L19.19 7.75H16.847C16.433 7.75 16.097 7.414 16.097 7C16.097 6.586 16.433 6.25 16.847 6.25H21C21.098 6.25 21.195 6.27011 21.287 6.30811C21.47 6.38411 21.616 6.53011 21.692 6.71411C21.73 6.80511 21.75 6.902 21.75 7Z" fill="#25314C" />
                          </svg>
                          <h1 className="text-[15px] text-gray-500">{t("Added in")} {item.combo_service_list.length} {t("Carts")}</h1>
                        </div>
                      </div>
                    })}
                  </div>
                </div>}

              </div>
            </div>}
        </div>}

    </div>
  )
}

export default Dashboard;
/* jshint ignore:end */